import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { fromAppointmentTypeQueryToAppointmentType } from "../../../../../../../adapters/v3/pages/BookAppointment/adapters/from-appointment-type-query-to-appointment-type.js";
import { GET_BOOK_APPOINTMENT_TYPE } from "../../../../../../../queries/v3/pages/BookAppointment/queries/get-book-appointment-type.js";
const useBookAppointmentType = () => {
  const [query, queryState] = useLazyQuery(
    GET_BOOK_APPOINTMENT_TYPE
  );
  const { locale } = useIntl();
  if (queryState.error) {
    console.error(queryState.error);
  }
  const getBookAppointmentType = React.useCallback(
    (id) => query({
      variables: { id },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    }),
    [query, locale]
  );
  const data = React.useMemo(
    () => fromAppointmentTypeQueryToAppointmentType(queryState.data?.appointmentType),
    [queryState.data]
  );
  return React.useMemo(
    () => [getBookAppointmentType, { ...queryState, data }],
    [getBookAppointmentType, queryState, data]
  );
};
export {
  useBookAppointmentType as default
};
//# sourceMappingURL=use-book-appointment-type.js.map
